export default __webpack_public_path__ + "static/media/highlight-6-new.94969600.png";